const translations = [
    {
        id: 'tracker',
        PL: "Monitorowanie wagi i treningów",
        EN: "Monitoring weight and workouts"
    },
    {
        id: 'calculator',
        PL: "Kalkulator wyliczania kosztów kredytu hipotecznego",
        EN: "Mortgage cost calculation"
    },
]

export default translations;



